// Compact gradient CTA pill. tone='glow' (default) → pink/coral/amber
// brand gradient; tone='volt' → cyan ad gradient.
export default function GradientPill({ label, icon, onClick, tone = 'glow', size = 'md', as = 'button', ...rest }) {
  const padding = size === 'lg' ? '10px 18px' : size === 'sm' ? '5px 10px' : '7px 14px';
  const fontSize = size === 'lg' ? 14 : size === 'sm' ? 11 : 12;
  const grad = tone === 'volt' ? 'var(--grad-volt)' : 'var(--grad-glow)';
  const color = tone === 'volt' ? '#04141B' : '#1a0a14';
  const shadow = tone === 'volt' ? '0 6px 14px rgba(91,233,255,0.35)' : 'var(--shadow-glow)';

  const Tag = as;
  return (
    <Tag
      onClick={onClick}
      {...rest}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        padding, fontSize, fontWeight: 900,
        borderRadius: 999,
        background: grad, color,
        boxShadow: shadow,
        border: 'none',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        ...(rest.style || {})
      }}
    >
      {icon ? <span>{icon}</span> : null}
      <span>{label}</span>
    </Tag>
  );
}
